import React, { FC } from "react";
import { cn } from "@/lib/utils";

interface Props {
  className?: string;
  text: string;
  value?: string;
}

const Badge: FC<Props> = ({ className, text, value }) => {
  return (
    <div
      className={cn(
        "px-2 py-1 font-normal font-patrick text-xs bg-zinc-500 leading-none ",
        "tracking-tight text-white rounded-3xl inline-flex justify-start items-start gap-1.5",
        className,
      )}
    >
      <span>{text}</span>
      <span className="font-semibold">{value}</span>
    </div>
  );
};

export default Badge;
